import { Pipe, PipeTransform } from '@angular/core';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import * as _ from 'lodash';

@Pipe({
    name: 'priorityText'
})
export class PriorityTextPipe implements PipeTransform {
    constructor(private translateService: GfTranslateService) {};

    transform(priority: string): string {
        var priorities = ['', this.translateService.translate('Very High'), this.translateService.translate('High'), 
            this.translateService.translate('Medium'), this.translateService.translate('Low'), this.translateService.translate('Very Low')];
        return _.get(priorities, priority, '');
    }
};